var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 15 15", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement("use", { xlinkHref: "#a" }),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { id: "a", fillRule: "evenodd", d: "M.825 6.144c-.03 2.894 2.347 5.313 5.25 5.344A5.334 5.334 0 0 0 11.49 6.18C11.516 3.264 9.148.857 6.22.826 3.245.794.855 3.149.825 6.144zm.683 4.058c-2.076-2.367-2.004-6.007.188-8.295a6.18 6.18 0 0 1 8.323-.555c2.626 2.105 3.114 6.194.759 8.884.043.029.096.052.134.09 1.306 1.303 2.611 2.606 3.912 3.915a.657.657 0 0 1 .168.315c.036.174-.056.314-.213.395a.396.396 0 0 1-.451-.048c-.04-.031-.074-.069-.11-.104l-3.884-3.884c-.039-.039-.069-.086-.106-.134a6.188 6.188 0 0 1-8.72-.58z" })
    )
  );
});